// react
import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PersonelDetailsData from './PersonelDetailsData';

function PersonelDetails(props) {
    const { layout } = props;

    let content;
    if (layout === 'classic') {
        content = (
            <PersonelDetailsData layout={layout} />
        );
    } else if (layout === 'full') {
        content = (
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-8 col-xl-8">
                    <PersonelDetailsData layout={layout} />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {content}
        </React.Fragment>
    );
}

PersonelDetails.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
};

PersonelDetails.defaultProps = {
    layout: 'classic',
};
const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(PersonelDetails);
